import { useQuery } from 'hooks/useCustomQuery';
import { useEffect } from 'react';

import { fetchTRSClusters } from 'API/TRSCluster/fetchTRSClusters';

const useGetTRSClusters = (setTableData, gridRef, colDefs) => {
    const query = useQuery({
        queryKey: ['TRSClusters'],
        queryFn: fetchTRSClusters,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: true,
    });

    // Handle data updates using useEffect instead of deprecated onSuccess
    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });

            // Apply default sorting when data is available
            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'name', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetTRSClusters;
